export const button: any = {
  pl: 'sm',
  pr: 'sm',
  bg: 'primary',
  color: 'white',
  fontSize: 'lg',
  fontWeight: 'bold',
  letterSpacing: 'normal',
  transitionDuration: 'short',

  transitionTimingFunction: 'easeInOut',

  css: ({ theme }) => ({
    paddingTop: '10px',
    paddingBottom: '10px',
    borderRadius: '4px',
    lineHeight: '28px',
    height: '42px',
    transitionProperty: 'background-color, color',
    ':active': {}, // disable default active style,
    '&[href]:hover, :hover:enabled': {
      backgroundColor: theme.colors.primaryDark
    },
    '&[href]:active:enabled, :active:enabled': {
      backgroundColor: theme.colors.primaryLight
    },
    '&[href]:visited, :visited': {
      color: theme.colors.white
    },
    '&[href]:focus, :focus': {
      backgroundColor: theme.colors.primaryLight,
      color: theme.colors.white
    },
    ':disabled': {
      backgroundColor: '#D9D7DF',
      color: '#A3A0B0',
      cursor: 'not-allowed'
    }
  }),
  variants: {
    textLink: {
      bg: 'transparent',
      borderRadius: 'none',
      boxShadow: 'none',
      css: ({ theme }: any) => ({
        height: 'auto',
        color: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: 'inherit',
        background: 'none',
        '&[href]:hover, :hover:enabled': {
          backgroundColor: 'transparent',
          textDecoration: 'underline'
        },
        '&[href]:active:enabled, :active:enabled': {
          backgroundColor: 'transparent'
        },
        '&[href]:focus, :focus': {
          backgroundColor: 'transparent',
          outline: '1px solid rgba(0, 103, 244, 0.5)'
        },
        ':disabled': {
          color: theme.colors.secondaryText,
          cursor: 'not-allowed'
        }
      })
    },

    secondary: {
      color: 'light',
      bg: 'secondary',
      css: ({ theme }: any) => ({
        ':hover': {}, // disable default hover style
        '&[href]:hover, :hover:enabled': {
          backgroundColor: theme.colors.secondaryLight,
          color: theme.colors.dark
        },
        '&[href]:active:enabled, :active:enabled': {
          backgroundColor: theme.colors.secondaryDark
        },
        '&[href]:focus, :focus': {
          backgroundColor: theme.colors.secondaryDark
        },
        ':disabled': {
          color: theme.colors.secondaryDarker,
          cursor: 'not-allowed'
        }
      })
    },
    //     accent: {
    //       bg: "accent",
    //       color: "light",
    //       css: ({ theme }: any) => ({
    //         "&[href]:hover, :hover:enabled": {
    //           backgroundColor: theme.colors.accentLight,
    //         },
    //         "&[href]:active:enabled, :active:enabled": {
    //           backgroundColor: theme.colors.accentDark,
    //         },
    //         "&[href]:focus, :focus": {
    //           backgroundColor: theme.colors.accentDark,
    //         },
    //         ":disabled": {
    //           color: "rgba(255, 255, 255, 0.3)",
    //           cursor: "not-allowed",
    //         },
    //       }),
    //     },
    border: {
      bg: 'transparent',
      color: 'primary',
      border: 'regular',
      boxShadow: 'none',
      css: ({ theme }: any) => ({
        // explicitly set border color to avoid intermediate value during `color` transition
        fontSize: theme.fontSizes.md,
        borderColor: theme.colors.primary,
        '&[href]:active:enabled, :active:enabled, &[href]:focus, :focus': {
          backgroundColor: 'transparent',
          borderColor: '#A3A0B0',
          color: '#A3A0B0'
        },
        ':disabled': {
          color: '#A3A0B0',
          borderColor: '#A3A0B0',
          cursor: 'not-allowed'
        },
        '&[href]:visited, :visited': {
          color: theme.colors.primary
        },
        '&[href]:hover, :hover:enabled, &[href]:visited:hover, :visited:hover': {
          backgroundColor: theme.colors.primary,
          color: theme.colors.white,
          borderColor: theme.colors.primary
        }
      })
    },
    //     borderSecondary: {
    //       bg: "transparent",
    //       color: "secondary",
    //       border: "regular",
    //       boxShadow: "none",
    //       css: ({ theme }: any) => ({
    //         // explicitly set border color to avoid intermediate value during `color` transition
    //         borderColor: theme.colors.secondary,
    //         "&[href]:hover, :hover, &[href]:hover:enabled, :hover:enabled": {
    //           backgroundColor: theme.colors.secondary,
    //           borderColor: theme.colors.secondary,
    //           color: theme.colors.white,
    //         },
    //         "&[href]:active:enabled, :active:enabled, &[href]:focus, :focus": {
    //           backgroundColor: theme.colors.primaryDarker,
    //           color: theme.colors.white,
    //         },
    //         ":disabled": {
    //           borderColor: theme.colors.primaryDarker,
    //           color: theme.colors.primaryDarker,
    //           cursor: "not-allowed",
    //         },
    //         "&[href]:visited, :visited": {
    //           color: theme.colors.secondary,
    //         },
    //       }),
    //     },
    //     borderWhite: {
    //       bg: "transparent",
    //       color: "white",
    //       border: "light",
    //       fontSize: "sm",
    //       boxShadow: "none",
    //       css: ({ theme }: any) => ({
    //         // explicitly set border color to avoid intermediate value during `color` transition
    //         borderColor: theme.colors.white,
    //         "&[href]:hover, :hover, &[href]:hover:enabled, :hover:enabled": {
    //           backgroundColor: theme.colors.light,
    //           borderColor: theme.colors.white,
    //           color: theme.colors.primary,
    //         },
    //         "&[href]:active:enabled, :active:enabled, &[href]:focus, :focus": {
    //           backgroundColor: theme.colors.primaryDarker,
    //           color: theme.colors.white,
    //         },
    //         ":disabled": {
    //           borderColor: theme.colors.white,
    //           color: theme.colors.white,
    //           cursor: "not-allowed",
    //         },
    //         "&[href]:visited, :visited": {
    //           color: theme.colors.white,
    //         },
    //       }),
    //     },
    transparent: {
      bg: 'transparent',
      color: 'primary',
      fontWeight: 'regular',
      boxShadow: 'none',
      css: ({ theme }: any) => ({
        '&[href]': {
          color: theme.colors.primary
        },
        '&[href]:hover, :hover:enabled': {
          backgroundColor: theme.colors.transparent,
          color: theme.colors.secondary
        },
        '&[href]:active:enabled, :active:enabled': {
          backgroundColor: theme.colors.transparent,
          color: theme.colors.secondary
        },
        '&[href]:focus, :focus': {
          backgroundColor: theme.colors.transparent,
          color: theme.colors.secondary
        },
        '&[href]:visited, :visited': {
          color: theme.colors.primary
        },
        ':disabled': {
          backgroundColor: theme.colors.transparent,
          color: theme.colors.secondaryDarker,
          cursor: 'not-allowed'
        }
      })
    }
    //     inverted: {
    //       bg: "light",
    //       color: "primaryText",
    //       css: ({ theme }: any) => ({
    //         "&[href]:hover, :hover:enabled": {
    //           backgroundColor: theme.colors.secondaryLighter,
    //         },
    //         "&[href]:active:enabled, :active:enabled": {
    //           backgroundColor: theme.colors.secondaryDarker,
    //           color: theme.colors.light,
    //         },
    //         ":disabled": {
    //           backgroundColor: theme.colors.secondaryText,
    //           color: theme.colors.primaryLight,
    //           cursor: "not-allowed",
    //         },
    //       }),
    //     },
    //     invertedBorder: {
    //       bg: "transparent",
    //       color: "light",
    //       border: "regular",
    //       css: ({ theme }: any) => ({
    //         // explicitly set border color to avoid intermediate value during `color` transition
    //         borderColor: theme.colors.light,
    //         "&[href]:hover, :hover:enabled": {
    //           backgroundColor: theme.colors.light,
    //           color: theme.colors.primary,
    //           borderColor: theme.colors.light,
    //         },
    //         "&[href]:active:enabled, :active:enabled": {
    //           backgroundColor: theme.colors.secondaryText,
    //           color: theme.colors.light,
    //         },
    //         ":disabled": {
    //           color: theme.colors.primaryLight,
    //           borderColor: theme.colors.primaryLight,
    //           cursor: "not-allowed",
    //         },
    //       }),
    //     },
    //     white: {
    //       bg: "white",
    //       border: "none",
    //       color: "primaryText",
    //       boxShadow: "none",
    //       css: ({ theme }: any) => ({
    //         ".themed-icon": {
    //           stroke: theme.colors.primaryDarker,
    //         },
    //         background: theme.colors.white,
    //         color: theme.colors.primaryDarker,
    //         "&[href]:hover:enabled, :hover:enabled": {
    //           ".themed-icon": {
    //             stroke: theme.colors.primaryDarker,
    //           },
    //         },
    //       }),
    //     },
    //     rounded: {
    //       borderRadius: "round",
    //     },
  }
};
